import React from 'react';

const FinalCTA = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      const offsetTop = contactSection.offsetTop - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="final-cta">
      <div className="container">
        <h2>Experience the Difference</h2>
        <p>Join teams who've transformed their data workflow in 21 days.</p>
        <div className="cta-buttons">
          <button
            className="btn-primary"
            onClick={scrollToContact}
          >
            Start Free Pilot (21 Days)
          </button>
          <button
            className="btn-secondary"
            onClick={scrollToContact}
          >
            Book Demo
          </button>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
